import { Box } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const InfoSubsectionContainer = styled(Box)`
  max-height: 100px;
  overflow: hidden;
  position: relative;
  margin-bottom: ${({ theme: { mp } }) => mp.xs};
  margin-top: ${({ theme: { mp } }) => mp.sm};

  /* Fade effect using gradient mask */
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(transparent, white);
    pointer-events: none;
  }
`

export const InfoParagraph = styled.p`
  font-weight: ${({ theme: { font } }) => font.weights.regular};
`
